import React, { useEffect, useState } from 'react'

export default function Meal({ index, meal }) {
    const [currentMeal, setMeal] = useState(meal)
    const { image, meal_name, slot, description, type } = currentMeal
    return (
        <div className="ibox-content" key={index}>
            <img src={image} className="img-fluid" alt="Meal" style={{ width: "100%", height: 220 }} />

            <div className="row my-1">
                <div className="col-8">
                    <h5 className='text-uppercase'>{meal_name}</h5>
                </div>
                <div className="col-4">
                    <h5 className='text-capitalize' style={{ fontSize: 10 }}>{slot}</h5>
                </div>
            </div>
            <div className="row mt-1">
                <div className="col-8">
                    <p className='text-capitalize'>{description}</p>
                </div>
                <div className="col-4">
                    <h5 className={`text-capitalize ${type}=='veg'?'text-success':'text-danger'`} style={{ fontSize: 8 }}>{type}</h5>
                </div>
            </div>
            {/* <AddOnCard meal_add_on={add_on} /> */}
        </div>
    )
}
